<template>
  <form ref="didiVerify" class="form--custom login__form" novalidate @submit.prevent="handleDidiVerify">
    <h2 class="login__title">{{ $t(`${namespace}.verification`) }}</h2>
    <p class="login__text">{{ $t(`${namespace}.didiVerifyTip`) }}</p>

    <label for="">{{ $t(`${namespace}.accessVerifyName`) }}</label>
    <v-text-field v-model="didiCode" name="didiCode" :placeholder="$t(`${namespace}.accessVerifyPlaceholder`)"
      :disabled="submittedStep2" v-validate.persist="{ required: true, didiCode: true }"
      :error-messages="errors.collect($t(`${namespace}.accessVerifyName`))"
      :data-vv-name="$t(`${namespace}.accessVerifyName`)" maxlength="6" required flat outline solo />

    <v-layout align-center justify-center row fill-height>
      <v-flex xs-6>
        <div class="submitVerifyWrap">
          <v-btn type="submit" color="warning--gradient" :disabled="!enableSubmitDidiVerifyCode"
            :loading="submittedStep2" round block depressed large>
            {{ $t(`${namespace}.submitVerify`) }}
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </form>
</template>

<script>
import userService from '@/services/user'
import { Omega, OmegaEventIds, OmegaBusiness, OmegaStatus } from 'common/omega'
export default {
  name: 'DidiVerifyForm',
  props: {
    ticket: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    submittedStep2: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.$validator.extend('didiCode', {
      getMessage: field => this.$t(`${this.namespace}.validatorError`),
      validate: value => {
        function validateDigits (string) {
          var pattern = /^\d{6}$/
          return pattern.test(string)
        }
        return validateDigits(value)
      }
    })
  },
  computed: {
    enableSubmitDidiVerifyCode () {
      return this.didiCode && !this.submittedStep2
    }
  },
  data () {
    return {
      namespace: 'Views.LoginPage',
      didiCode: null
    }
  },
  methods: {
    async handleDidiVerify () {
      // 登录步骤二点击验证
      Omega.trackBusiness(
        OmegaEventIds.tech_b2bv3_login,
        {
          business: OmegaBusiness.login,
          type: 'step2',
          status: OmegaStatus.op,
          params: {
            type: 'dShield'
          }
        }
      )
      const isValid = await this.$validator.validateAll()
      if (!isValid) return
      const { email, didiCode } = this
      this.$emit('changeSubmittedStep2', true)
      try {
        const user = await userService.codeVerify(email, didiCode, this.ticket)
        this.$emit('handleLoggedUser', user)
      } catch (err) {
        Omega.trackBusiness(
          OmegaEventIds.tech_b2bv3_login,
          {
            business: OmegaBusiness.login,
            type: 'step2',
            status: OmegaStatus.error,
            msg: err?.message,
            params: {
              type: 'dShield'
            }
          }
        )
        this.$emit('handleError', err)
      }
    }
  },
  mounted () {
    try {
      if (this.$refs.didiVerify) {
        // 登录步骤二成功渲染
        Omega.trackBusiness(
          OmegaEventIds.tech_b2bv3_login,
          {
            business: OmegaBusiness.login,
            type: 'step2',
            status: OmegaStatus.sw,
            params: {
              type: 'dShield'
            }
          }
        )
      } else {
        Omega.trackBusiness(
          OmegaEventIds.tech_b2bv3_login,
          {
            business: OmegaBusiness.login,
            type: 'step2',
            status: OmegaStatus.swError,
            params: {
              type: 'dShield'
            }
          }
        )
      }
    } catch (e) {
      console.log('omega上报错误')
    }
  }
}
</script>

<style lang="scss" scoped>
.v-tooltip__content {

  // background: #ffffff !important;
  .not_receive_tooltip {
    color: #FFFFFF;
    font-size: 14px;
  }
}
</style>
